// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__rNRrs","active":"spinner_active__Nl7V-","spin":"spinner_spin__uZ9yq"};